import { useNavigate } from 'react-router-dom';
import { useAdminNotifi } from '../../context/Admins/AdminNotifiContext';
import moment from 'moment';
import 'moment/locale/ar'
import Pagination from '../../utilities/Pagination';

export default function AdminNotifi() {
    const { orderNotifi, currentPage, setCurrentPage } = useAdminNotifi();
    const navigate = useNavigate();
    const totalPages = orderNotifi?.data?.paginationInfo.totalPagesCount;

    moment.locale('en');
    const totalCount = orderNotifi?.data?.totalCount;
    if (!orderNotifi) return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;

    return (
        <div className="container my-3 rounded bg-light-gray position-relative p-3">
            {totalCount !== 0 ?
                <table className="table table-hover">
                    <thead className="table-dark">
                        <tr>
                            <th scope="col">الوقت والتاريخ</th>
                            <th scope="col">الإشعار</th>
                            <th scope="col">الحالة</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orderNotifi?.data?.result.map((notify) => (
                            <tr role="button" key={notify.notificationId} onClick={() => navigate(`/admin/setting/services`)}>
                                <td className="col-4">{moment(notify.notification?.createdAt).format('HH:mm , DD-MM-YYYY')}</td>
                                <td className="col text-start">
                                    {notify.notification?.body}
                                </td>
                                <td className={`col ${!notify.seen ? "text-success" : "text-secondary"}`}>{!notify.seen ? "جديد" : "مقروء"}</td>
                            </tr>
                        ))}
                    </tbody>

                </table>
                : <div className="text-center bg-warning text-white w-75 m-auto rounded-1 p-1">لا يوجد إشعارات</div>
            }
            <Pagination
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages} />

            {/* {totalCount !== 0 && <p className="badge bg-info text-white">آخر 10 تنبيهات</p>} */}
        </div>
    )
}